import { useQuery } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";
import { AiFillCloseCircle, AiOutlineMenu } from "react-icons/ai";
import { FaRegUserCircle } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";
import { IoCarOutline, IoClose } from "react-icons/io5";
import { LuUser2, LuWallet } from "react-icons/lu";
import { RiLogoutCircleLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAccount, useBalance, useChains } from "wagmi";
import { GET_USER_DETAILS } from "../../apollo/operations";
import { logo } from "../../assets/images";
import useOutsideClick from "../../hooks/useOutsideClick";
import { setCurrStep } from "../../redux/slices/addVehicleSlice";
import { setDashboardType } from "../../redux/slices/dashboardSlice";
import {
  clearUser,
  setRegisterAsHost,
  setUserDetails,
} from "../../redux/slices/userSlice";
import { RootState, persistor } from "../../redux/store";
import { getWalletFromIndexedDB } from "../../utils/generatedWallet";
import { showToast } from "../../utils/showToast";
import { TransakOnRamp } from "..";
import { formatEther } from "viem";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [generatedWallet, setGeneratedWallet] = useState<`0x${string}`>();

  const dropdownRef = useRef<HTMLDivElement>(null);

  useOutsideClick(dropdownRef, () => {
    setShowDropdown(false);
  });

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const { address } = useAccount();
  const chains = useChains();
  const balanceData = useBalance({
    address: generatedWallet ?? address,
  });

  const navHeading: {
    name: string;
    link: string;
  }[] = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "About Us",
      link: "/about",
    },
    {
      name: "Team",
      link: "/team",
    },
    {
      name: "News",
      link: "/news",
    },
    {
      name: "Contact Us",
      link: "/contact",
    },
  ];

  const authNavHeading: {
    name: string;
    link: string;
  }[] = [
    {
      name: "Marketplace",
      link: "/vehicles",
    },
    {
      name: "Trips",
      link: "/trips",
    },
    {
      name: "Host",
      link: "/host",
    },
  ];

  const userID = window.localStorage.getItem("user");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { loading, error, data } = useQuery(GET_USER_DETAILS, {
    variables: {
      where: {
        id: userID,
      },
    },
    onCompleted: (data) => {
      // console.log(data);
      dispatch(setUserDetails(data.user));
    },
    onError: (error) => {
      // console.log(error.message);
      // navigate("/auth");
    },
  });

  const handleBecomeHost = () => {
    if (data) {
      navigate("/host");
    } else {
      dispatch(setRegisterAsHost(true));
      showToast("Please login to continue", "error");
      navigate("/auth");
    }
  };

  const handleLogout = async () => {
    dispatch(clearUser());
    dispatch(setCurrStep(0));
    await persistor.purge();
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("zzzzzzzz");
    navigate("/auth");
  };

  const userDetails = useSelector(
    (state: RootState) => state?.user?.userDetails
  );

  useEffect(() => {
    async function getWallet() {
      const wallets = await getWalletFromIndexedDB();

      if (wallets?.length > 0) {
        setGeneratedWallet(wallets[0]?.address);
        window.localStorage.setItem("isGeneratedWallet", "true");
      }
    }

    getWallet();
  }, []);

  return (
    <>
      <div className="w-full bg-white sticky top-0 z-[99] ">
        <div className="bg-white w-[80%] lg:w-[90%] xl:w-[80%] flex justify-between items-center mx-auto py-6">
          <div className="flex gap-2 items-center">
            <div className="flex lg:hidden" onClick={toggleSidebar}>
              {isOpen ? (
                <AiFillCloseCircle size={30} />
              ) : (
                <AiOutlineMenu size={30} />
              )}
            </div>
            <div className=" hidden md:flex">
              <Link to="/">
                <h1 className="text-darkGreen flex items-center gap-2 text-[22px] font-Poppins text-normal font-regular cursor-pointer">
                  <img src={logo} alt="" className="w-[50px] h-[50px]" />
                  ECOMOTO
                </h1>
              </Link>
            </div>
          </div>

          <div className="hidden  lg:flex">
            <ul className=" flex flex-row gap-6 text-darkText font-Poppins text-[16px] font-normal ">
              {userDetails
                ? authNavHeading.map((nav, index) => (
                    <li
                      className={`text-darkGreen cursor-pointer hover:underline ${
                        pathname === nav.link ? "text-lightGreen" : ""
                      }`}
                      key={index}
                    >
                      <Link to={nav.link}>{nav.name}</Link>
                    </li>
                  ))
                : navHeading.map((nav, index) => (
                    <li
                      className={`text-darkGreen cursor-pointer hover:underline ${
                        pathname === nav.link ? "text-lightGreen" : ""
                      }`}
                      key={index}
                    >
                      <Link to={nav.link}>{nav.name}</Link>
                    </li>
                  ))}
            </ul>
          </div>
          {userDetails ? (
            <div
              ref={dropdownRef}
              className=" flex gap-8 items-center relative"
            >
              <button
                onClick={handleBecomeHost}
                className="hidden lg:flex py-[8px] px-[25px] max-h-fit border border-solid border-darkGreen bg-white text-darkGreen rounded-md "
              >
                Become a Host
              </button>
              <div className="flex gap-4">
                {/* <HiOutlineBell size={30} className="cursor-pointer" /> */}
                {/* <PiChatTeardropText
                size={30}
                className="cursor-pointer hidden lg:flex"
              /> */}
              </div>
              <div className="flex gap-4 items-center">
                {/* <p className="hidden lg:flex font-Poppins text-[12px] font-semibold text-midGreen cursor-pointer ">
                Help?
              </p> */}
                <div
                  onClick={() => setShowDropdown(!showDropdown)}
                  className="flex gap-2 items-center cursor-pointer "
                >
                  {/* <img src={Annie} alt="" className=" rounded-full h-10 w-10" /> */}
                  {userDetails?.firstName && userDetails?.lastName ? (
                    <p className=" rounded-full h-10 w-10 font-Inter uppercase font-medium flex items-center justify-center text-sm text-white bg-midGreen">
                      {userDetails?.firstName[0]}
                      {userDetails?.lastName[0]}
                    </p>
                  ) : (
                    <FaRegUserCircle
                      size={20}
                      className="cursor-pointer text-midGreen h-10 w-10 "
                    />
                  )}
                  <FaChevronDown size={20} className=" text-[#8A8787] " />
                </div>
              </div>
              {showDropdown && (
                // <div className="absolute top-14 right-0  bg-white shadow-2xl p-6 rounded-xl flex flex-col gap-3 ">
                //   <div
                //     onClick={() => {
                //       dispatch(setDashboardType("lessee"));
                //       navigate("/dashboard");
                //     }}
                //     className="flex gap-3 items-center cursor-pointer group"
                //   >
                //     <LuUser2 className=" text-[35px] text-[#01262F] p-2 bg-[#ffc619] rounded-full" />
                //     <p className=" text-midGreen font-medium text-[20px] leading-5 group-hover:underline">
                //       Lessee Dashboard
                //     </p>
                //   </div>
                //   <div
                //     onClick={() => {
                //       dispatch(setDashboardType("lessor"));
                //       navigate("/dashboard");
                //     }}
                //     className="flex gap-3 items-center cursor-pointer group"
                //   >
                //     <IoCarOutline className=" text-[35px] text-[#ffc619] p-2 bg-[#01262F] rounded-full" />
                //     <p className=" text-midGreen font-medium text-[20px] leading-5 group-hover:underline">
                //       Lessor Dashboard
                //     </p>
                //   </div>
                //   {(address || generatedWallet) && (
                //     <div className="flex gap-3 items-center cursor-pointer group">
                //       <LuWallet className=" text-[35px] text-midGreen p-2 bg-[#ECF1F2] rounded-full" />
                //       <p className=" text-darkGreen font-medium text-[20px] leading-5 group-hover:underline">
                //         {/* {address?.slice(0, 6)}...{address?.slice(-4)} */}
                //         {generatedWallet ? (
                //           generatedWallet.slice(0, 6) +
                //           "..." +
                //           generatedWallet.slice(-4)
                //         ) : (
                //           <w3m-button
                //             balance="show"
                //             label="Connect to Ecomoto"
                //             loadingLabel="Connecting..."
                //           />
                //         )}
                //       </p>
                //     </div>
                //   )}
                //   `<div
                //     onClick={handleLogout}
                //     className="flex gap-3 items-center cursor-pointer group"
                //   >
                //     <RiLogoutCircleLine className=" text-[35px] text-[#FD3434] p-2 bg-[#ECF1F2] rounded-full" />
                //     <p className=" text-[#FD3434] font-medium text-[20px] leading-5 group-hover:underline">
                //       Log out
                //     </p>
                //   </div>
                // </div>

                <div className="absolute right-0 mt-2 w-80 top-14 bg-white py-3 z-10 shadow-2xl p-6 rounded-xl flex flex-col gap-3">
                  <div
                    onClick={() => {
                      dispatch(setDashboardType("lessee"));
                      navigate("/dashboard");
                    }}
                    className="flex gap-3 items-center cursor-pointer group"
                  >
                    <LuUser2 className=" text-[35px] text-[#01262F] p-2 bg-[#ffc619] rounded-full" />
                    <p className=" text-midGreen font-medium text-[14px] leading-5 group-hover:underline">
                      Lessee Dashboard
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      dispatch(setDashboardType("lessor"));
                      navigate("/dashboard");
                    }}
                    className="flex gap-3 items-center cursor-pointer group"
                  >
                    <IoCarOutline className=" text-[35px] text-[#ffc619] p-2 bg-[#01262F] rounded-full" />
                    <p className=" text-midGreen font-medium text-[14px] leading-5 group-hover:underline">
                      Lessor Dashboard
                    </p>
                  </div>
                  {(address || generatedWallet) && (
                    <div className="flex gap-3 items-center cursor-pointer group">
                      <p className=" text-darkGreen font-medium text-[14px] leading-5 group-hover:underline">
                        {generatedWallet ? (
                          <button
                            onClick={() => {
                              openModal();
                              setShowDropdown(false);
                            }}
                            className="flex gap-3 items-center w-full text-left py-2 text-sm text-midGreen font-medium group-hover:underline"
                          >
                            <LuWallet
                              className={` text-[35px] text-midGreen p-2 bg-[#ECF1F2] rounded-full ${
                                address && "hidden"
                              }`}
                            />
                            <span>
                              ({generatedWallet.slice(0, 6)}...
                              {generatedWallet.slice(-4)})
                            </span>
                          </button>
                        ) : (
                          <w3m-button
                            balance="hide"
                            label="Connect to Ecomoto"
                            loadingLabel="Connecting..."
                          />
                        )}
                      </p>
                    </div>
                  )}

                  <div
                    onClick={handleLogout}
                    className="flex gap-3 items-center cursor-pointer group"
                  >
                    <RiLogoutCircleLine className=" text-[35px] text-[#FD3434] p-2 bg-[#ECF1F2] rounded-full" />
                    <p className=" text-[#FD3434] font-medium text-[14px] leading-5 group-hover:underline">
                      Log out
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className=" hidden lg:flex gap-5">
              {/* <Link to="/host"> */}
              <button
                onClick={handleBecomeHost}
                className=" py-[8px] px-[25px] border border-solid border-darkGreen rounded-md hover:bg-lightGreen hover:border-white "
              >
                Become a Host
              </button>
              <Link to="/auth">
                <button className="py-[8px] px-[48px] text-white hover:text-midGreen bg-lightGreen rounded-md font-semibold hover:bg-white border hover:border-darkGreen">
                  Get Started
                </button>
              </Link>
            </div>
          )}

          {isOpen && (
            <div className="flex lg:hidden">
              {/* Sidebar */}
              <aside
                className={`fixed top-0 right-0 h-full w-60 bg-white z-40 transition-transform ${
                  isOpen ? "translate-x-0" : "translate-x-full"
                }`}
              >
                {/* Sidebar content */}
                <div className="py-8 px-4">
                  <ul className="flex-col space-y-6 text-darkText font-Poppins text-[16px] font-normal flex text-left p-5">
                    {userDetails
                      ? authNavHeading.map((nav, index) => (
                          <li
                            className={`hover:text-lightGreen cursor-pointer ${
                              pathname === nav.link ? "text-lightGreen" : ""
                            }`}
                            key={index}
                          >
                            <Link to={nav.link}>{nav.name}</Link>
                          </li>
                        ))
                      : navHeading.map((nav, index) => (
                          <li
                            className={`hover:text-lightGreen cursor-pointer ${
                              pathname === nav.link ? "text-lightGreen" : ""
                            }`}
                            key={index}
                          >
                            <Link to={nav.link}>{nav.name}</Link>
                          </li>
                        ))}
                    {/* <Link to="/">
                    <li className="hover:text-lightGreen cursor-pointer">
                      Home
                    </li>
                  </Link>
                  <Link to="/about">
                    <li className="hover:text-lightGreen cursor-pointer">
                      About Us
                    </li>
                  </Link>
                  <Link to="/team">
                    <li className="hover:text-lightGreen cursor-pointer">
                      Team
                    </li>
                  </Link>
                  <Link to="/news">
                    <li className="hover:text-lightGreen cursor-pointer">
                      News
                    </li>
                  </Link>
                  <Link to="/contact">
                    <li className="hover:text-lightGreen cursor-pointer">
                      Contact Us
                    </li>
                  </Link> */}
                  </ul>
                  <div className="flex flex-col p-5 gap-5">
                    <Link to="/host">
                      <button
                        type="button"
                        className="py-[8px] px-[25px] border border-solid border-darkGreen rounded-md hover:bg-lightGreen hover:border-white"
                      >
                        Become a Host
                      </button>
                    </Link>

                    {!userDetails && (
                      <Link to="/auth">
                        <button
                          type="button"
                          className="py-[8px] px-[48px] bg-lightGreen rounded-md font-semibold hover:bg-white border hover:border-darkGreen"
                        >
                          Get Started
                        </button>
                      </Link>
                    )}
                  </div>
                </div>
              </aside>

              {/* Overlay */}
              {isOpen && (
                <div
                  className="fixed top-0 left-0 w-full h-full bg-black opacity-25 z-30"
                  onClick={toggleSidebar}
                ></div>
              )}
            </div>
          )}
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 transition-opacity duration-300">
          <div
            className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl transform transition-all duration-300 ease-out"
            style={{
              opacity: isModalOpen ? 1 : 0,
              transform: isModalOpen ? "scale(1)" : "scale(0.95)",
            }}
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-3xl font-bold text-gray-800">Wallet</h2>
              <button
                title="close modal"
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
              >
                <IoClose className="h-6 w-6" />
              </button>
            </div>
            <div className="space-y-6">
              <div className="bg-gray-100 p-4 rounded-lg">
                <p className="text-sm text-gray-500 mb-1">Address</p>
                <p className="font-mono text-lg break-all">{generatedWallet}</p>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm text-gray-500 mb-1">Network</p>
                  <p className="font-semibold text-lg">{chains[0].name}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-500 mb-1">Balance</p>
                  <p className="font-semibold text-lg">
                    {formatEther(balanceData.data?.value as bigint)}{" "}
                    {balanceData.data?.symbol}
                  </p>
                </div>
              </div>
              {/* <TransakOnRamp
                user={userDetails!}
                price={100}
                fiat="USD"
                crypto="USDC"
                address={(generatedWallet ?? address) as `0x${string}`}
              /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
